frappe.provide("brand_club");

$(document).on('app_ready', function() {
	setTimeout(() => {
        if (frappe.boot.brand_club_release_note) {
            brand_club.show_release_note(frappe.boot.brand_club_release_note);
        }
	}, 1000);

});

brand_club.show_release_note = function(note) {
    let d = new frappe.ui.Dialog({
        title: __("System Update: {0}", [note.version]),
        size: 'large',
        fields: [
            {
                fieldtype: 'HTML',
                fieldname: 'content',
                options: `
                    <div class="padding">
                        <div class="flex justify-between items-center mb-4">
                            <h3 class="text-xl font-bold">${note.title}</h3>
                        </div>
                        <div class="release-notes-content text-muted leading-relaxed" style="max-height: 400px; overflow-y: auto;">
                            ${note.description}
                        </div>
                    </div>
                `
            }
        ],
        primary_action_label: __("Got it"),
        primary_action: function() {
            d.hide();
        },
        onhide: function() {
            frappe.call({
                method: "brand_club.api.mark_release_note_seen",
                args: {
                    version: note.version
                },
                callback: function() {
                    delete frappe.boot.brand_club_release_note;
                }
            });
        }
    });

    d.show();
};
